import { createAction } from "@reduxjs/toolkit";

export const actions = {
  clearDraft: createAction("experienceBuilder/clearDraft"),
  // Bridged from the plugin's `ig-setPreviewStateProcessed` postMessage: the
  // preview processed a preview-state update without reloading (live-applied or a
  // content-level no-op). The continuation settle waits on this (raced against a
  // reload) so a follow-up turn captures a stable page.
  previewStateProcessed: createAction(
    "experienceBuilder/previewStateProcessed"
  ),
};
